module.exports = __webpack_public_path__ + "static/media/coffee_machine.aa40bb2b.png";